import React from 'react';

import styles from '../compensationSubmissionFormStyles.scss';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

const CompensationFormButtons = ({ values, isSubmitting, setFieldValue }) => {
  if (values.category === 'actual') {
    if (values.mode === 'new') {
      return (
        <div className={styles.buttonContainer}>
          <Button
            text="Save & Next"
            type={BUTTON_TYPES.PRIMARY}
            size={BUTTON_SIZES.LARGE}
            isLoading={isSubmitting}
          />
        </div>
      );
    } else if (values.mode === 'edit') {
      return (
        <div className={styles.buttonContainer}>
          <Button text="Update & Next" type={BUTTON_TYPES.PRIMARY} size={BUTTON_SIZES.LARGE} />
        </div>
      );
    }
  } else if (values.category === 'estimated') {
    return (
      <div className={styles.buttonContainer}>
        <Button
          text="Submit as Final"
          onClick={() => setFieldValue('status', 'published')}
          type={BUTTON_TYPES.PRIMARY}
          size={BUTTON_SIZES.LARGE}
          isLoading={isSubmitting}
        />
        <Button
          text="Save as Draft"
          type={BUTTON_TYPES.PRIMARY}
          size={BUTTON_SIZES.LARGE}
          isLoading={isSubmitting}
        />
      </div>
    );
  }
};

export default CompensationFormButtons;
